import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";

function Appereance() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Appereance" breadcrumbItem="Appereance" />
          <h4>Appereance</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Appereance;
